import { useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import classes from './RSVPModal.module.scss'
import colors from '../../../../../assets/styles/globals.scss'

import StockProfilePic from '../../../../../assets/images/mock/StockProfilePic.png'
import MCElement from '../../../../common/MCElement'
import Input from '../../../../common/form/Input'
import SubmitButton from '../../../../common/buttons/SubmitButton'
import Modal from '../../../../common/Modal'
import { ReactComponent as TimeIcon } from '../../../../../assets/images/common/icons/time-icon.svg'
import { ReactComponent as LocationIcon } from '../../../../../assets/images/common/icons/location-icon.svg'
import { ReactComponent as FlagIcon } from '../../../../../assets/images/common/icons/simple-flag-icon.svg'
import classNames from 'classnames'

const RSVPModal = ({ event, showModal, closeModal, onSubmit, waitlist }) => {
  const enrollment = event.students[0].enrollment
  const [formData, setFormData] = useState({
    confirmation: waitlist ? 'waitlisted' : enrollment.status,
    note: event.students[0].enrollment.note,
  })

  const eventDate = moment(event.date)

  const handleSelectAttendance = (confirmation) => {
    if (formData.confirmation !== confirmation) {
      setFormData({ ...formData, confirmation: confirmation })
    }
  }

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      contentLabel='Confirmation Modal'
      className={classNames(classes.RSVPModal, waitlist && classes.waitlistModal)}
      autoFocus
    >
      <div className={classes.modalContent}>
        <div className={classes.eventDate}>
          <span className={classes.monthName}>{ eventDate.format('MMM') }</span>
          <span className={classes.dayNumber}>{ eventDate.format('DD') }</span>
          <span className={classes.dayName}>{ eventDate.format('ddd') }</span>
        </div>
        <div className='w-100'>
          <p className={classes.title}>{event.name}</p>
          <p className={classes.subtitle}>{event.seriesName}</p>

          <div className={classes.eventData}>
            <TimeIcon className={classes.icon}/>
            <span className={classes.text}>
              {event.date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }).toLowerCase()}
            </span>
          </div>

          {event.location &&
            <div className={classes.eventData}>
              <LocationIcon className={classes.icon}/>
              <span className={classes.text}>{event.location}</span>
            </div>
          }

          <div className={classes.eventData}>
            <FlagIcon className={classes.icon}/>
            <span className={classes.text}>{event.format}</span>
          </div>

          <div className={classes.studentsProfiles}>
            {event.students.slice(0, 4).map((student) =>
              <div
                className={classes.profileImg}
                key={student.id}
                style={{
                  backgroundImage: student.avatarUrl
                    ? `url(${student.avatarUrl})`
                    : `url(${StockProfilePic})`,
                }}
              />
            )}
            {event.students.length > 4 && <div className={classes.moreProfiles}>+ {event.students.length - 4} more</div>}
            {event.students.length === 1 && <div className={classes.studentName}>{event.students[0].firstName} {event.students[0].lastName}</div>}
          </div>

          {!waitlist &&
          <>
            <div className={classes.sectionHeader}>
              Confirm Attendance
            </div>
            <div
              onClick={() => handleSelectAttendance('confirmed')}
              className='d-flex format-option-tee-times mb-2'
              role='button'
              onKeyDown={null}
              tabIndex={0}
            >
              <div className='mr-3'>
                <MCElement
                  type='radio'
                  onKeyDown={(e) => {
                    e.key === 'Enter' && handleSelectAttendance('confirmed')
                  }}
                  primaryColor={formData.confirmation === 'confirmed' ? colors.secondaryColor : colors.lightNavy}
                  isSelected={formData.confirmation === 'confirmed'}
                />
              </div>
              <span className={classes.sectionText}>Attending</span>
            </div>
            <div
              onClick={() => handleSelectAttendance('declined')}
              className='d-flex format-option-Shotgun'
              role='button'
              onKeyDown={null}
              tabIndex={0}
            >
              <div className='mr-3'>
                <MCElement
                  type='radio'
                  onKeyDown={(e) => {
                    e.key === 'Enter' && handleSelectAttendance('declined')
                  }}
                  primaryColor={formData.confirmation === 'declined' ? colors.secondaryColor : colors.lightNavy}
                  isSelected={formData.confirmation === 'declined'}
                />
              </div>
              <span className={classes.sectionText}>Not Attending</span>
            </div>
          </>
          }
          {!waitlist && <div className={classes.sectionHeader}>
            Add an Optional Message
          </div> }
          <div className={classes.sectionText}>
            {waitlist ?
              enrollment.status === 'waitlisted' ?
                `You're #${enrollment.waitlistOrder} on the waitlist for this event. There is no other action needed.\
                You can update your note to the coach below.\
                \n\n Send a note to Coach:`
                :
                'This event has reached capacity.\
                 \n\nYou can join the waitlist below and send a message to the coach if you’d like to be considered.'
              : 'Optional - Please send any time/pairing request or anything we should be aware of.'
            }
          </div>
          <Input
            name='note'
            type='textarea'
            onChange={handleInputChange}
            value={formData.note}
            styles={{ inputContainer: { height: '90px' } }}
          />
        </div>

      </div>
      <SubmitButton
        onClick={() => onSubmit(
          { ...formData, id: event?.students[0].enrollment.id, eventId: event.id, userId: event?.students[0].id },
          enrollment.status
        )}
        buttonMessage={waitlist ? enrollment.status === 'waitlisted' ? 'Save note' : 'Join Waitlist' : 'Send'}
        buttonColor='orange-button'
        className={classes.sendRSVPButton}
      />
    </Modal>
  )
}

RSVPModal.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    seriesName: PropTypes.string,
    location: PropTypes.string,
    date: PropTypes.object,
    format: PropTypes.string,
    students: PropTypes.array,
  }),
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
  onSubmit: PropTypes.func,
  waitlist: PropTypes.bool,
}

export default RSVPModal
